import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useContext, useEffect, useState } from 'react'
import { Check2Circle, FilterCircle, Layers, Trash } from 'react-bootstrap-icons'
import QuestionnaireBuilderContext from '../QuestionnaireBuilderProvider'

export default function QBuilderComponentOptions({ Component, isNew, onClose, busy }) {
    const { handleClone, handleChange, handleRemove } = useContext(QuestionnaireBuilderContext)


    const [mode, setMode] = useState('')

    const _handleClose = () => {
        if (busy) {
            setMode('loading')
            onClose()
        } else {
            onClose()
        }
    }

    useEffect(() => {
        if (busy === false) {
            setMode('')
            onClose()
        }
        // loaded()
    }, [busy])

    if (mode === 'loading') {
        return <div className='text-center'><FontAwesomeIcon icon={faSpinner} spin /> Saving changes, please wait . . .</div>
    }

    return (
        <div className='d-flex justify-content-end'>
            {
                !isNew
                    ?
                    <>
                        <div
                            onClick={(e) => handleClone(Component)}
                            className='d-flex flex-column align-items-center me-2'>
                            <Layers />
                            <small>Clone</small>
                        </div>
                        <div
                            onClick={(e) => handleChange(Component, 'New')}
                            className='d-flex flex-column align-items-center me-2'>
                            <FilterCircle />
                            <small>Change component type</small>
                        </div>
                    </>
                    :
                    <></>
            }

            <div
                onClick={(e) => handleRemove(Component)}
                className='d-flex flex-column align-items-center me-2'>
                <Trash />
                <small>Remove Component</small>
            </div>
            {
                !isNew
                    ?

                    <div
                        onClick={(e) => _handleClose()}
                        className='d-flex flex-column align-items-center me-2  ' style={{ fontWeight: 'bold' }} >
                        <Check2Circle />
                        <small>Done</small>
                    </div>
                    :
                    <></>
            }
        </div>
    )
}
